import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Injector, OnInit } from '@angular/core';
import { User } from '@app/models';
import { PoFilesComponent } from '@app/modules/po-details/components/po-files/po-files.component';
import { AppConstants } from '@app/shared/constants/app.constants';
import { FileSizePipe } from '@app/shared/pipes';
import { Store } from '@ngrx/store';
import { TitleDividerComponent } from '../../title-divider/title-divider.component';
import { ContractBaseComponent } from '../contract-base.component';
import { LucideAngularModule, FileText, Link2, FileType, ExternalLink } from 'lucide-angular';

@Component({
  standalone: true,
  selector: 'contract-documents-c',
  templateUrl: './contract-documents-c.component.html',
  styleUrls: ['./contract-documents-c.component.scss'],
  imports: [
    CommonModule,
    LucideAngularModule,
    TitleDividerComponent,
    PoFilesComponent
  ]
})
export class ContractDocumentsCComponent extends ContractBaseComponent implements OnInit {
  readonly FileText = FileText;
  readonly Link2 = Link2;
  readonly FileType = FileType;
  readonly ExternalLink = ExternalLink;
  
  addSubmittedDocumentFileEventEmitter: EventEmitter<any> = new EventEmitter<any>();
  
  constructor(public injector: Injector, public store: Store<{ user: User }>) {
    super(injector, store)
  }


  ngOnInit(): void {
  }

  getCognitoFormUrl() {
    let entry = {
      ContractNumber: this.contract.customer_po_number,
      CreatedBy: this.currentUser.email
    }
    return 'https://www.cognitoforms.com/IONContracts/_2024CHPPINTERIMREPORT?entry=' + JSON.stringify(entry)
  }


  getCognitoFormRelevantUrl() {
    if (this.contract.contract_type.includes("CHPP")) {
      return this.getCognitoFormCHPPGrantURL();
    }
    if (this.contract.contract_type.includes("LAP")) {
      return this.getCognitoFormLAPGrantURL();
    }
    return '';
  }

  getCognitoFormCHPPGrantURL() {
    let entry = {
      ContractNumber: this.contract.customer_po_number,
      CreatedBy: this.currentUser.email
    }
    return 'https://www.cognitoforms.com/IONContracts/_2024SomersetCountyCHPPGrantFinalReport?entry=' + JSON.stringify(entry)
  }
  getCognitoFormLAPGrantURL() {
    let entry = {
      ContractNumber: this.contract.customer_po_number,
      CreatedBy: this.currentUser.email
    }
    return 'https://www.cognitoforms.com/IONContracts/_2024SomersetCountyLAPGrantFinalReport?entry=' + JSON.stringify(entry)
  }

  getCognito2025CHPPInterimReportURL() {
    return 'https://www.cognitoforms.com/IONContracts/_2025CHPPINTERIMREPORTDueOnOrBeforeJUNE232025PLEASENOTETh'
  }

  getCognito2025CHPPFinalReportURL() {
    return 'https://www.cognitoforms.com/IONContracts/_2025CHPPFinalReportNarrativeAndStatisticsForms'
  }

  getCognito2025LAPFinalReportURL() {
    return 'https://www.cognitoforms.com/IONContracts/_2025LAPFinalReportNarrativeAndStatisticsForm'
  }

  isCH() {
    return (this.customer && this.customer.name.includes('C+H'));
  }
}
